<template>
  <div class="text-center">
    <v-snackbar v-model="popup" :timeout="timeout">
      {{ popupText }}

      <template v-slot:action="{ attrs }">
        <v-btn plain color="blue" text v-bind="attrs" @click="popup = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <th class="text-center">
      <v-dialog
        v-model="dialog"
        min-width="300px"
        max-width="400px"
        :loading="loading"
        content-class="rounded-xl"
      >
        <template v-slot:activator="{ value, on: dialog }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                :disabled="value"
                class="ma-2"
                small
                v-on="{ ...tooltip, ...dialog }"
              >
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Создать новый шаблон</span>
          </v-tooltip>
        </template>
        <template>
          <form>
            <v-card>
              <v-card-title> Добавление нового шаблона </v-card-title>
              <v-card-text>
                <v-text-field
                  label="Имя шаблона"
                  required
                  v-model.lazy="name"
                  @blur="$v.name.$touch()"
                  :error-messages="nameErrors"
                >
                  > Имя
                </v-text-field>
                <!-- <v-select
              label="Точное значение"
              small
              clearable
              :items="fighters"
              v-model="selected"
            ></v-select> -->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  class="ma-2 pa-2"
                  small
                  :disabled="this.$v.$invalid"
                  @click="saveTemplate"
                >
                  Добавить
                  <v-icon right>mdi-playlist-plus</v-icon>
                </v-btn>
                <!-- <v-btn class="success" right @click="successClicked">
              <v-icon>mdi-check</v-icon>

            </v-btn> -->
              </v-card-actions>
            </v-card>
          </form>
        </template>
      </v-dialog>
    </th>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import api from "../config/api";
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    name: {
      required,
      isUnique(value) {
        if (value === "") return true;

        return api
          .post(this.check_url, { name: this.name })
          .then((response) => {
            console.log(response);
            this.nameOk = true;
            return !response.data.success;
          })
          .catch(() => {
            this.nameOk = false;
            return false;
          });
      },
    },
  },
  data: () => ({
    dialog: false,
    url: "/templates/save_template/",
    check_url: "/templates/check_name_unique/",
    name: "",
    nameOk: false,
    templates: null,
    popup: false,
    popupText: "",
    selectedFilters: {},
    timeout: 2000,
    loading: true,
    filterDict: {
      id: "ID матча",
      timestamp__ts__date: "Дата",
      timestamp__time_of_day__contains: "Время",
      score__first_score: "Первый набрал",
      score__second_score: "Второй набрал",
      //   score__game: "Счёт",
      //   score__game__in: "Счёт входит в список",
      //   score__game__not_in: "Счёт не входит в список",
      fighters__left_fighter: "Левый боец",
      fighters__right_fighter: "Правый боец",
      coefs__wl: "Кф на П1 в матче",
      coefs__wl__range: "Диапазон кф на П2 в матче",
      coefs__wr: "Кф на П2 в матче",
      coefs__wr__range: "Диапазон кф на П2 в матче",
      coefs__wlr: "Кф на П1 в раунде",
      coefs__wlr_range: "Диапазон кф на П1 в раунде",
      coefs__wrr: "Кф на П2 в раунде",
      coefs__wrr_range: "Диапазон кф на П2 в раунде",

      coefs__f: "Кф на Фаталити",
      coefs__f__range: "Диапазон кф на Фаталити",
      coefs__f__in: "кф на Фаталити входит в список",
      coefs__f__not_in: "кф на Фаталити не входит в список",

      coefs__b: "Кф на Бруталити",
      coefs__b__range: "Диапазон кф на Бруталити",
      coefs__b__in: "кф на Бруталити входит в список",
      coefs__b__not_in: "кф на Бруталити не входит в список",

      coefs__r: "Кф на Без добивания в матче",
      coefs__r__range: "Диапазон кф на Без добивания",
      coefs__r__in: "кф на Без добивания входит в список",
      coefs__r__not_in: "кф на Без добивания не входит в список",

      coefs__flaw: "Кф на Чистую победу",
      coefs__flaw__range: "Диапазон кф на Чистую победу",
      coefs__flaw__in: "кф на Чистую победу входит в список",
      coefs__flaw__not_in: "кф на Чистую победу не входит в список",

      five_total_more: "Кф на тотал 5.5Б",
      five_total_less: "Кф на тотал 5.5М",
      totals__five_total_more__in: "Кф на тотал 5.5Б входит в список",
      totals__five_total_less__in: "Кф на тотал 5.5М входит в список",
      totals__five_total_more__not_in: "Кф на тотал 5.5Б не входит в список",
      totals__five_total_less__not_in: "Кф на тотал 5.5М не входит в список",
      totals__five_total_less__range: "Кф на тотал 5.5М находится в диапазоне",
      totals__five_total_more__range: "Кф на тотал 5.5М находится в диапазоне",

      six_total_more: "Кф на тотал 6.5Б",
      six_total_less: "Кф на тотал 6.5М",
      totals__six_total_more__in: "Кф на тотал 6.5Б входит в список",
      totals__six_total_less__in: "Кф на тотал 6.5М входит в список",
      totals__six_total_more__not_in: "Кф на тотал 6.5Б не входит в список",
      totals__six_total_less__not_in: "Кф на тотал 6.5М не входит в список",
      totals__six_total_less__range: "Кф на тотал 6.5М находится в диапазоне",
      totals__six_total_more__range: "Кф на тотал 6.5М находится в диапазоне",

      seven_total_more: "Кф на тотал 7.5Б",
      seven_total_less: "Кф на тотал 7.5М",
      totals__seven_total_more__in: "Кф на тотал 7.5Б входит в список",
      totals__seven_total_less__in: "Кф на тотал 7.5М входит в список",
      totals__seven_total_more__not_in: "Кф на тотал 7.5Б не входит в список",
      totals__seven_total_less__not_in: "Кф на тотал 7.5М не входит в список",
      totals__seven_total_less__range: "Кф на тотал 7.5М находится в диапазоне",
      totals__seven_total_more__range: "Кф на тотал 7.5М находится в диапазоне",

      eight_total_more: "Кф на тотал 8.5Б",
      eight_total_less: "Кф на тотал 8.5М",
      totals__eight_total_more__in: "Кф на тотал 8.5Б входит в список",
      totals__eight_total_less__in: "Кф на тотал 8.5М входит в список",
      totals__eight_total_more__not_in: "Кф на тотал 8.5Б не входит в список",
      totals__eight_total_less__not_in: "Кф на тотал 8.5М не входит в список",
      totals__eight_total_less__range: "Кф на тотал 8.5М находится в диапазоне",
      totals__eight_total_more__range: "Кф на тотал 8.5М находится в диапазоне",

      rounds_view_f__one_view_f: "Тип добивания в 1м раунде",
      rounds_view_f__two_view_f: "Тип добивания во 2м раунде",
      rounds_view_f__three_view_f: "Тип добивания во 3м раунде",
      rounds_view_f__four_view_f: "Тип добивания во 4м раунде",
      rounds_view_f__five_view_f: "Тип добивания во 5м раунде",
      rounds_view_f__six_view_f: "Тип добивания во 6м раунде",
      rounds_view_f__seven_view_f: "Тип добивания во 7м раунде",
      rounds_view_f__eight_view_f: "Тип добивания во 8м раунде",
      rounds_view_f__nine_view_f: "Тип добивания во 9м раунде",
      rounds_view__one_view: "Победитель в 1м раунде",
      rounds_view__two_view: "Победитель во 2м раунде",
      rounds_view__three_view: "Победитель в 3м раунде",
      rounds_view__four_view: "Победитель в 4м раунде",
      rounds_view__five_view: "Победитель в 5м раунде",
      rounds_view__six_view: "Победитель в 6м раунде",
      rounds_view__seven_view: "Победитель в 7м раунде",
      rounds_view__eight_view: "Победитель в 8м раунде",
      rounds_view__nine_view: "Победитель в 9м раунде",

      // score__first_score: "Первый набрал",
      score__first_score__in: "Первый набрал число из списка",
      score__first_score__not_in: "Первый набрал число не из списка",
      // second__first_score: "Второй набрал",
      score__second_score__in: "Второй набрал число из списка",
      score__second_score__not_in: "Второй набрал число не из списка",
    },
  }),

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      const name_required = !this.$v.name.required;
      name_required && errors.push("Имя шаблона - обязательное поле");
      if (!name_required) {
        !this.$v.name.isUnique &&
          errors.push("Шаблон с таким именем уже существует");
      }
      return errors;
    },
    filters() {
      return this.getFormData();
    },
    curTemplate() {
      // console.log("Current template: " + this.getCurrentTemplate());
      return this.getCurrentTemplate();
    },
  },

  methods: {
    ...mapGetters(["getCurrentTemplate", "getSettings"]),
    ...mapActions([
      "cleanSettings",
      "setTemplateUID",
      "setCurrentTemplate",
      "fetchUserTemplates",
    ]),

    saveTemplate: function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.cleanSettings();
      // console.log("Saving template...");
      var settings = this.getSettings();
      //   var name = "template";
      // var name = this.name;
      var uid = "";
      var name = this.name;
      var name_for_set = name;
      api
        .post(this.url, { settings, name })
        .then((response) => {
          console.log("response:" + JSON.stringify(response.data));
          uid = response.data.uid;
          this.popupText = "Шаблон успешно добавлен";
          this.popup = true;
          this.dialog = false;
          this.name = "";
        })
        .catch((error) => {
          console.log("ERROR IN SAVE TEMPLATE:" + JSON.stringify(error));
          this.popupText = "Что-то пошло не так :(";
          this.popup = true;
        })
        .finally(() => {
          // console.log("Setting Template uid: " + uid);
          this.setTemplateUID({ value: uid });
          // console.log("Setting Template name: " + name_for_set);
          this.setCurrentTemplate({ value: name_for_set });
          this.fetchUserTemplates();
        });
    },
  },
};
</script>

<style scoped></style>
